module.exports = __webpack_public_path__ + "img/logo_pragmabytes.96922ffe.svg";